(function (app, ng) {

    /*
Service: figModalComponent
Allow us to instantiate $mdDialog with a component instead of templates and controllers

This service serves mostly as a drop-in replacement for $mdDialog.alert etc, and the result can be used with $mdDialog.show
All other properties passed in are passed to $mdDialog (clickOutsideToClose, targetElement, etc)

before: 
    var alert = $mdDialog.alert({template:"...", controller: ..., clickOutsideToClose: true});
    $mdDialog.show(alert);

after:
    var alert = figModalComponent.alert({component:..., clickOutsideToClose: true});
    $mdDialog.show(alert);

Currently supports:
    figModalComponent.alert({...}), figModalComponent.confirm({...}), figModalComponent.prompt({...})
Could be extended to hook into whenever someone adds other presets, we should be able to handle them here as well
    */
    app.provider("figModalComponent", [function () {
        this.$get = ["$mdDialog", "$injector", function ($mdDialog, $injector) {
            var service = {};
            //TODO: expand this to hook into $mdDialog's addPreset, so that any method created there is reflected here 
            var methods = ["alert", "confirm", "prompt"];
            ng.forEach(methods, function (method) {
                service[method] = function (arg) {
                    //https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1033
                    //when you register a component, angular registers it as a directive, and a service named "yourComponent"+"Directive"
                    var component = $injector.get(arg.component + "Directive")[0];
                    var param = ng.extend({},
                        arg,
                        {
                            //here we grab all the relevant bits we need from the component as it was defined, and attach them to the rest of the params
                            template: component.template,
                            templateUrl: component.templateUrl,
                            controller: component.controller,
                            controllerAs: component.controllerAs,
                            component: undefined //remove component from the arg list since we're taking care of it
                        });
                    return $mdDialog[method](param);
                };
            });

            return service;
        }];
    }]);

})(window.app, window.angular); // jshint ignore:line